<template>
  <ValidationObserver class="merchant-preview" ref="form" tag="div">
    <h3 class="merchant-preview__section">公司資料</h3>
    <div class="merchant-preview__field">
      <h4>公司/集團名稱</h4>
      <div>{{ item.companyName }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>商戶/網店名稱</h4>
      <div>{{ item.name }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>商業登記號碼</h4>
      <BusinessRegistrationCertificate
        :value="item.brc"
        :disabled="true"
      ></BusinessRegistrationCertificate>
    </div>
    <div v-if="item.brcImage" class="merchant-preview__field">
      <h4>商戶登記證書</h4>
      <img class="merchant-image" :src="item.brcImage | imagePath('merchantBrc')" />
    </div>
    <div v-if="item.logo" class="merchant-preview__field">
      <h4>品牌標誌</h4>
      <img class="merchant-image"
           :src="item.logo | imagePath('merchantLogo')"
      >
    </div>
    <div class="merchant-preview__field">
      <h4>公司電郵</h4>
      <div>{{ item.email }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>公司聯絡電話</h4>
      <div>{{ item.hotline }} {{ getIsUseWhatsApp(item.isUseWhatsApp) }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>公司地址</h4>
      <div>{{ item.address }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>公司網頁</h4>
      <div>{{ item.website }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>公司簡介</h4>
      <div v-html="item.desc"></div>
    </div>
    <div class="merchant-preview__field">
      <h4>業務性質</h4>
      {{ translatedMerchantTagWithSubTags }}
    </div>
    <div class="merchant-preview__field">
      <h4>店鋪類型</h4>
      <div>{{ getTranslatedShopType(item.shopType) }}</div>
    </div>
    <div v-if="item.banner" class="merchant-preview__field">
      <h4>宣傳圖片</h4>
      <img class="merchant-banner"
           :src="item.banner | imagePath('merchantBanner')"
      >
    </div>
    <div v-if="item.images" class="merchant-preview__field">
      <h4>圖片集</h4>
      <b-carousel
        class="merchant-banner"
        controls
        indicators
        :interval="0"
      >
        <b-carousel-slide
          v-for="imagePath in item.images"
          :key="imagePath"
          :img-src="imagePath | imagePath('merchantImages')"
        >
        </b-carousel-slide>
      </b-carousel>
    </div>
    <div class="merchant-preview__field">
      <h4>申請帳戶類型</h4>
      <div>{{ getTranslatedAccType(item.accTypeInRegister) }}</div>
    </div>
    <hr>
    <h3 class="merchant-preview__section">聯絡人資料</h3>
    <div class="merchant-preview__field">
      <h4> 帳戶名稱</h4>
      <div>{{ item.username }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>聯絡人名稱</h4>
      <div>{{ item.contactName }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>聯絡電郵</h4>
      <div>{{ item.contactEmail.join(', ') }}</div>
    </div>
    <div class="merchant-preview__field">
      <h4>聯絡電話</h4>
      <div>{{ item.contactPhone }}</div>
    </div>
    <hr>
    <AGCCheckbox v-model="confirmTerms"
                 class="mb-3"
                 rules="terms"
                 required
    >
      <span class="terms-label">
        本人/本公司已詳細閱讀及同意U Lifestyle的
        <a target="_blank" href="https://www.ulifestyle.com.hk/aboutus">
          私隱政策與使用條款
        </a>、 U Lifestyle商戶中心的
        <a href="javascript:void(0)" v-b-modal.tnc-modal>使用條款</a>
        ， 以及授權U Lifestyle於旗下網站及應用程式發佈已審批的相關優惠。
      </span>
    </AGCCheckbox>
    <b-modal id="tnc-modal"
          size="lg"
          title="商家優惠平台使用條款和細則"
          no-stacking
          centered
          hide-footer
          scrollable>
          <TNCText></TNCText>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue';
import TNCText from '@/views/static/content/TNCText.vue';
import BusinessRegistrationCertificate from '@/components/BusinessRegistrationCertificate.vue';
import formMixin from '../../mixins/form';
import imagePath from '../../filters/image-path';
import AGCCheckbox from '../form/AGCCheckbox.vue';

export default {
  mixins: [formMixin],
  components: {
    AGCCheckbox,
    TNCText,
    BusinessRegistrationCertificate,
    BCarousel,
    BCarouselSlide,
  },
  props: ['item', 'merchantTagWithSubTags'],
  data: () => ({
    confirmTerms: false,
  }),
  computed: {
    sortedTags() {
      return [...this.item.tags].sort();
    },
    translatedMerchantTagWithSubTags() {
      let result = '';
      const tagIdAndSubTagIdWithNameDict = this.getTagIdAndSubTagIdWithNameDict();
      this.item.tags.forEach(({ id, children: subTagIds }, tagIndex) => {
        const tagName = tagIdAndSubTagIdWithNameDict[id];
        result += tagName;
        subTagIds.forEach((subTagId, index) => {
          if (index) {
            result += `${tagIdAndSubTagIdWithNameDict[subTagId]}`;
          } else {
            result += ` - ${tagIdAndSubTagIdWithNameDict[subTagId]}`;
          }
          if (subTagIds.length > index + 1) {
            result += ', ';
          }
        });
        if (this.item.tags.length > tagIndex + 1) {
          result += ', ';
        }
      });
      return result;
    },
  },
  filters: {
    imagePath,
  },
  methods: {
    getTagIdAndSubTagIdWithNameDict() {
      const tagIdAndSubTagIdWithNameDict = {};
      this.merchantTagWithSubTags.result.forEach(({ id, name, children }) => {
        if (children) {
          tagIdAndSubTagIdWithNameDict[id] = name;
          children.forEach((child) => {
            tagIdAndSubTagIdWithNameDict[child.id] = child.name;
          });
        }
      });
      return tagIdAndSubTagIdWithNameDict;
    },
    getTranslatedShopType(type) {
      const SHOP_TYPE = {
        physical: '實體商店',
        internet: '網上商店',
        both: '實體店及網店',

      };
      return SHOP_TYPE[type];
    },
    getTranslatedAccType(type) {
      const ACC_TYPE = {
        NORMAL: '普通商戶(只供上載積分優惠券)',
        PREMIUM: '星級商戶(可上載付費優惠券及積分優惠券)',
      };
      return ACC_TYPE[type];
    },
    getIsUseWhatsApp(type) {
      const TYPE = {
        true: '(只限Whatsapp聯絡)',
      };
      return TYPE[type];
    },
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style scoped lang="scss">
.merchant-preview {
  &__section {
    color: #3a4047;
    font-size: 17px;
    margin-bottom: 22px;
    font-weight: 400;
  }

  &__field {
    margin-bottom: 24px;

    & > h4 {
      color: #174169;
      font-size: 15px;
      margin-bottom: 4px;
      font-weight: 400;
    }

    & > div,
    & > span {
      color: #3a4047;
      font-size: 15px;
    }
  }

  hr {
    margin-top: 8px;
    margin-bottom: 24px;
  }

  &::v-deep {
    .custom-control-label {
        &::before, &::after {
          top: 0.35rem;
        }
      }
    .brc {
      input {
        font-size: inherit;
        padding: 0;
        &:nth-child(1) {
          width: 3.5rem;
        }
        &:nth-child(3) {
          width: 1.5rem;
        }
        &:nth-child(5) {
          width: 1rem;
        }
        &:nth-child(7) {
          width: 1rem;
        }
        &:nth-child(9) {
          width: 0.5rem;
        }
      }
    }
  }
}

.merchant-image {
  width: 150px;
  height: 150px;
}

.merchant-banner {
  max-width: 100%;
}

.terms-label {
  color: #3A4047;
  font-size: 14px;

  a {
    color: #1A73E9;
  }
}
</style>
